<template>
    <div class="columns is-centered">
        <div class="column is-6">
            <form @submit.prevent="submit">
                <h4 class="title is-4">
                    Admin Activate
                </h4>

                <p class="subtitle">
                    Before you can login with your Staff account you'll need to activate your account.
                    <br />
                    You'll receive a link by email which will allow you to set a secure Portal password.
                </p>

                <hr class="mb-5" />

                <FormNotification />

                <SavingNotification>
                    Sending...
                </SavingNotification>

                <div class="columns">
                    <div class="column">
                        <b-field label="Veco™ Username">
                            <b-input
                                v-model="Username"
                                v-validate="{ required: true }"
                                type="text"
                                name="Username"
                            />
                        </b-field>
                    </div>

                    <div class="column">
                        <b-field label="Veco™ Password">
                            <b-input
                                v-model="Password"
                                v-validate="{ required: true }"
                                type="password"
                                name="Password"
                                password-reveal
                            />
                        </b-field>
                    </div>
                </div>

                <b-field label="Veco™ Email">
                    <b-input
                        v-model="Email"
                        v-validate="{ required: true, email: true }"
                        type="email"
                        name="Email"
                    />
                </b-field>

                <hr class="mb-5" />

                <nav class="level">
                    <div class="level-left">
                        <div class="level-item">
                            <b-button
                                type="is-info"
                                tag="button"
                                :disabled="isSending"
                                native-type="submit"
                            >
                                Submit
                            </b-button>
                        </div>
                    </div>
                    <div class="level-right">
                        <div class="level-item">
                            <router-link :to="{ name: 'staff-login' }">
                                Need to login?
                            </router-link>
                        </div>
                    </div>
                </nav>
            </form>
        </div>
    </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields';
import Form from '../../mixins/form.js';

export default {
    mixins: [
        Form,
    ],

    computed: {
        ...mapFields('staff', [
            'staff.Username',
            'staff.Email',
            'staff.Password',
        ]),
    },

    methods: {
        submit() {
            this.isSuccess = null;

            this.validate()
            .then((result) => {
                if (! result) {
                    return;
                }

                this.$store.dispatch('staff/signUp')
                .then((response) => {
                    this.statusMessage = response.data.message;
                    this.statusType = 'success';
                    this.isSuccess = true;
                })
                .catch((error) => {
                    this.parseServerErrors(error);
                    this.isSuccess = false;
                })
                .then(() => {
                    this.isSending = false;
                });
            });
        },
    },
};
</script>
